import BookingFlow from "@/components/BookingFlow";
import RateCard from "@/pages/dashboard/RateCard";
import { useAuth } from "@/context/AuthContext";

export default function Rates() {
  const { user } = useAuth();

  // Contract-rate accounts (like the app) see their rate card, not standard quotes
  if (user?.rate_card_enabled) return <RateCard />;

  return (
    <div data-testid="rates-page" className="space-y-6 max-w-6xl">
      <div>
        <p className="text-xs font-mono font-bold uppercase tracking-[0.2em] text-blaze">Rate Calculator</p>
        <h1 className="font-display font-black tracking-tight text-3xl sm:text-4xl mt-1">Live quotes, one-tap booking</h1>
        <p className="text-sm text-zinc-500 mt-2">B2C parcels, B2B freight and Air express — same engine as the app, wallet debits sync everywhere.</p>
      </div>
      <BookingFlow />
    </div>
  );
}
